import { render } from "./event-poll.vue?vue&type=template&id=beb11daa&scoped=true&lang=pug"
import script from "./event-poll.vue?vue&type=script&lang=js"
export * from "./event-poll.vue?vue&type=script&lang=js"

import "./event-poll.vue?vue&type=style&index=0&id=beb11daa&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb11daa"]])

export default __exports__